export default __webpack_public_path__ + "assets/margin-onboarding-4-6fe86039890739c6438e5bd43175a54a.png";